import React, { useState, useEffect } from 'react';
import gsap from 'gsap';
import axios from 'axios';
import './Contact.scss';

function Contact() {
  const [serverState, setServerState] = useState({
    submitting: false,
    status: null,
  });
  const handleServerResponse = (ok, msg, form) => {
    setServerState({
      submitting: false,
      status: { ok, msg },
    });
    if (ok) {
      form.reset();
    }
  };
  const handleOnSubmit = (e) => {
    e.preventDefault();
    const form = e.target;
    setServerState({ submitting: true });
    axios({
      method: 'post',
      url: 'https://formspree.io/f/xdoygana',
      data: new FormData(form),
    })
      .then((r) => {
        handleServerResponse(true, 'Thanks!', form);
      })
      .catch((r) => {
        handleServerResponse(false, r.response.data.error, form);
      });
  };

  useEffect(() => {
    let tl = gsap.timeline({
      ease: 'power0',
      scrollTrigger: {
        trigger: '.form-container',
        start: 'top 75%',
        end: 'bottom 25%',
        toggleActions: 'play none  reverse',
      },
    });

    tl.from('.contact h1', {
      y: '-14vw',
      duration: 1,
    });
  }, []);

  return (
    <section className="contact">
      <div className="box">
        <h1>
          Contact Me <hr />
        </h1>
      </div>

      <div className="form-container">
        <form onSubmit={handleOnSubmit}>
          <div>
            <label htmlFor="name ">
              <h5>Name</h5>
            </label>

            <input
              type="text"
              id="user"
              name="user"
              placeholder="Finn AM"
              required
            />
          </div>
          <div>
            <label htmlFor="email">
              <h5>Email</h5>
            </label>
            <input
              type="email"
              id="email"
              name="email"
              placeholder="Finn@example.com"
              required
            />
          </div>
          <div>
            <label htmlFor="message"></label>
            <h5>Messages</h5>
            <textarea
              name="message"
              id="message"
              placeholder="Drag bottom right to expand more space"
              required
            ></textarea>
            <i>
              *This contact form is using formspree, it goes straight to my
              email.
            </i>
          </div>
          <button type="submit" disabled={serverState.submitting}>
            Send Messages
          </button>
          {serverState.status && (
            <p className={`status`}>
              {serverState.status.ok
                ? `Thanks For your feedback`
                : `Sorry, something went wrong, we'll try to fix it ASAP`}
            </p>
          )}
        </form>
      </div>
    </section>
  );
}

export default Contact;
